export class AutoSequenciaSerieEntity {
  serie = null;
  sequencia = null;

  constructor(autoSequeciaSerie) {
    this.serie = autoSequeciaSerie.serie;
    this.sequencia = autoSequeciaSerie.sequencia;
  }
}
